module.exports = __webpack_public_path__ + "static/media/illust_home_webedit.5b7130a6.png";